import type { ClearanceType } from "@services/departure/types";
import { getClearanceType } from "@services/departureServiceApi";
import { useQuery } from "@tanstack/react-query";

export const useClearanceTypeQuery = (vesselCallId?: string) =>
  useQuery<ClearanceType>({
    queryKey: ["clearance-type", vesselCallId],
    queryFn: () => getClearanceType(vesselCallId!),
    enabled: Boolean(vesselCallId),
  });
